import React, { useState, useEffect } from 'react';
import { supabase } from './lib/supabase';
import Welcome from './components/Welcome';
import Assessment from './components/Assessment';
import Complete from './components/Complete';
import Invalid from './components/Invalid';

export default function App() {
  const [tokenData, setTokenData] = useState(null);
  const [screen, setScreen]       = useState('loading');
  const [error, setError]         = useState(null);

  const token = window.location.pathname.split('/a/')[1];

  useEffect(() => {
    if (!token) { setScreen('invalid'); return; }
    loadToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  async function loadToken() {
    const { data, error } = await supabase
      .from('survey_tokens')
      .select('*')
      .eq('token', token)
      .single();

    if (error || !data) { setScreen('invalid'); return; }
    if (data.status === 'completed') { setTokenData(data); setScreen('complete'); return; }
    if (data.expires_at && new Date(data.expires_at) < new Date()) {
      setError('This assessment link has expired. Please contact your broker.');
      setScreen('invalid');
      return;
    }

    setTokenData(data);
    setScreen('welcome');
  }

  async function handleStart() {
    await supabase.from('survey_tokens')
      .update({ opened_at: new Date().toISOString(), status: 'opened' })
      .eq('token', token);
    setScreen('assessment');
  }

  function handleComplete() {
    setScreen('complete');
  }

  if (screen === 'loading')    return <Loader />;
  if (screen === 'invalid')    return <Invalid message={error} />;
  if (screen === 'welcome')    return <Welcome tokenData={tokenData} onStart={handleStart} />;
  if (screen === 'assessment') return <Assessment tokenData={tokenData} onComplete={handleComplete} />;
  if (screen === 'complete')   return <Complete tokenData={tokenData} />;
  return null;
}

function Loader() {
  return (
    <div style={{
      height:'100vh', display:'flex', alignItems:'center',
      justifyContent:'center', background:'#0a0a0a',
      color:'#666', fontSize:14, fontFamily:'system-ui',
    }}>
      Loading...
    </div>
  );
}
